import React from "react";
import $ from "jquery";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";
import * as GC from "../../../../common/common";

class AddPlanningPeriod extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      naam: "",
      omschrijving: "",
      naamRequiredAlert: "",
      code: GC.CodeAutoFill("Planningsperiode"),
      begin: "", //GC.curday("-"),
      end: "", //GC.curday("-"),
      active: true,
      flexibelinplannen: true,
      beginRequiredAlert: false,
      endRequiredAlert: false,
      codeRequiredAlert: false,
      codeAlertText: "",
    };
    this.baseState = this.state;
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  resetForm = async () => {
    await this.setState(this.baseState);
    await this.setState({ code: GC.CodeAutoFill("Planningsperiode") });
  };

  addParentFolder(childId) {
    var that = this;
    var parentId = $("#tree-parent-id").val();
    var model = { folder: parentId };

    omnimap
      .AddParentFolderAction(
        model,
        childId,
        window.$catalog_management_units_token
      )
      .then((result) => {
        console.log(result);
      });
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });

    if (value != "" && name == "begin") {
      this.setState({ beginRequiredAlert: false });
    }
    if (value != "" && name == "end") {
      this.setState({ endRequiredAlert: false });
    }
    if (value != "" && name == "naam") {
      this.setState({ naamRequiredAlert: false });
    }
  }

  async handleSubmit(event) {
    event.preventDefault();
    $("#cover-spin").show(0);

    var horizon_begin = this.state.begin + "T00:00:00.000Z";
    var horizon_end = this.state.end + "T00:00:00.000Z";
    this.state.naam == ""
      ? await this.setState({ naamRequiredAlert: true })
      : await this.setState({ naamRequiredAlert: false });
    this.state.code == ""
      ? await this.setState({
          codeRequiredAlert: true,
          codeAlertText: "required",
        })
      : await this.setState({ codeRequiredAlert: false, codeAlertText: "" });
    this.state.begin == ""
      ? await this.setState({ beginRequiredAlert: true })
      : await this.setState({ beginRequiredAlert: false });
    this.state.end == ""
      ? await this.setState({ endRequiredAlert: true })
      : await this.setState({ endRequiredAlert: false });
    var model = {
      relationships: { definition: { code: "PLANNINGSPERIODE" } },
      content: {
        algemeen: {
          actief: this.state.active,
          flexibelinplannen: this.state.flexibelinplannen,
          code: this.state.code,
          naam: this.state.naam,
          omschrijving: this.state.omschrijving,
          startdatum: this.state.begin,
          einddatum: this.state.end,
        },
      },
    };

    let isUnique = true;
    let uniqueModel = {
      content: [
        {
          and_or: "AND",
          datatype: "STRING",
          key: "algemeen-code",
          values: [this.state.code],
        },
      ],
      definitions: [process.env.REACT_APP_CATALOG_M_UNITS],
      sorting: [],
    };

    //** code isunique control.
    await omnimap
      .FillTableAction(uniqueModel, 1, window.$catalog_management_units_token)
      .then((result) => {
        if (result.data && result.data.length > 0) {
          isUnique = false;
          this.setState({
            codeRequiredAlert: true,
            codeAlertText: "is not unique",
          });
        }
      });

    if (
      this.state.beginRequiredAlert !== true &&
      this.state.endRequiredAlert !== true &&
      this.state.naamRequiredAlert !== true &&
      this.state.codeRequiredAlert !== true &&
      isUnique === true
    ) {
      var data = await omnimap.SaveOrEditAction(
        model,
        "POST",
        "",
        window.$catalog_management_units_token
      );
      if (data.result.status === "OK") {
        this.addParentFolder(data.data["identification"]);
        window.$catalog_management_units_newInsertId =
          data.data["identification"];

        CallBackFunctions.WerkplanSavedCallBack(
          window.$catalog_management_units_token
        );
      }
    } else {
      $("#cover-spin").hide(0);
    }
  }

  async componentDidMount() {
    var that = this;
    $(document).on("click", "#planningsperiode_toevoegen", function () {
      $("#planningPeriod_toevoegen_modal").modal("show");
      that.resetForm();
    });
  }

  render() {
    return (
      <div
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        id="planningPeriod_toevoegen_modal"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Nieuwe Planningsperiode</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <label
                className={
                  this.state.naamRequiredAlert
                    ? "modale-submit-alert-block"
                    : ""
                }
              >
                Naam *
              </label>{" "}
              <label
                className={
                  this.state.naamRequiredAlert
                    ? "modale-submit-alert-block"
                    : "modale-submit-alert-none"
                }
              >
                {"\u00A0"} required
              </label>
              <input
                id="beheereenheid_naam"
                type="input"
                className="form-control"
                placeholder="Naam"
                name="naam"
                value={this.state.naam}
                onChange={this.handleInputChange}
              />
              <label
                className={
                  this.state.codeRequiredAlert
                    ? "modale-submit-alert-block"
                    : ""
                }
              >
                Code *
              </label>
              <label
                className={
                  this.state.codeRequiredAlert
                    ? "modale-submit-alert-block"
                    : "modale-submit-alert-none"
                }
              >
                {"\u00A0"} {this.state.codeAlertText}
              </label>
              <input
                id="beheereenheid_code"
                type="input"
                className="form-control"
                placeholder="code"
                name="code"
                value={this.state.code}
                onChange={this.handleInputChange}
              />
              <label>Omschrijving</label>
              <input
                type="input"
                className="form-control"
                name="omschrijving"
                value={this.state.omschrijving}
                onChange={this.handleInputChange}
              />
              <label
                className={
                  this.state.beginRequiredAlert
                    ? "modale-submit-alert-block"
                    : ""
                }
              >
                Startdatum *
              </label>
              <label
                className={
                  this.state.beginRequiredAlert
                    ? "modale-submit-alert-block"
                    : "modale-submit-alert-none"
                }
              >
                {"\u00A0"}required
              </label>
              <input
                id="beheereenheid_begin"
                type="date"
                className="form-control"
                placeholder="Horizon Begin"
                name="begin"
                value={this.state.begin}
                onChange={this.handleInputChange}
              />
              <label
                className={
                  this.state.endRequiredAlert ? "modale-submit-alert-block" : ""
                }
              >
                Einddatum *
              </label>
              <label
                className={
                  this.state.endRequiredAlert
                    ? "modale-submit-alert-block"
                    : "modale-submit-alert-none"
                }
              >
                {"\u00A0"}required
              </label>
              <input
                id="beheereenheid_end"
                type="date"
                className="form-control"
                placeholder="Horizon Einde"
                name="end"
                value={this.state.end}
                onChange={this.handleInputChange}
              />
              <label>Flexibel inplannen</label>
              <label className="switch">
                <input
                  id="beheereenheid_active"
                  type="checkbox"
                  defaultChecked
                  name="flexibelinplannen"
                  value={this.state.flexibelinplannen}
                  onChange={this.handleInputChange}
                />
                <span className="slider-checkbox round" />
              </label>{" "}
              <br />
              <label>Actief</label>
              <label className="switch">
                <input
                  id="beheereenheid_active"
                  type="checkbox"
                  defaultChecked
                  name="active"
                  value={this.state.active}
                  onChange={this.handleInputChange}
                />
                <span className="slider-checkbox round" />
              </label>
              <br />
              <br />
            </div>
            <div className="modal-footer">
              <button
                type="button"
                id="save_beheereenheid"
                className="btn-modal"
                onClick={this.handleSubmit.bind(this)}
              >
                Verwerken
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddPlanningPeriod;
